module.exports = __webpack_public_path__ + "ndown_white_arrow.png";